/*
 * Copyright (c) 2025, Glasswing AI, Inc.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 * Glasswing AI, Inc. ("Confidential Information").
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Glasswing AI, Inc.
 */
import { Container, Row, Col } from 'react-bootstrap';
import { JsonEditor } from 'json-edit-react'

function ProbeDetailCurl({ data }) {
  const detail = data.detail;

  return (
    <Container fluid overflow-auto>
        <Row>
            <Col>
                <h2>Address: {detail?.curl?.addr}:{detail?.curl?.port}</h2>
                <div>Type: {detail?.probe_name}</div>
                <div>Browser: {detail?.curl?.browser}</div>
                <div>URL: {detail?.curl?.url}</div>
                <div>Proto: {detail?.curl?.proto}</div>
            </Col>
        </Row>
        <Row>
            <Col>
                <h3>Metadata</h3>
                <JsonEditor
                    data={detail.metadata}
                    viewOnly
                />
            </Col>
            <Col>
                <h3>Payload</h3>
                <pre>
                    {detail?.payload}
                </pre>
            </Col>
        </Row>
        <Row>
            <pre>
            </pre>
        </Row>
    </Container>
  );
}

export default ProbeDetailCurl;